
import React from 'react';
import styles from './SignOutButton.module.css';
import { Link } from 'react-router-dom';

const SignOutButton = () => {
    return (
        <Link to="/signout" style={{ textDecoration: 'none' }}>
            <button className={styles.container}>
                サインアウト
            </button>
        </Link>
    );
};

export default SignOutButton;
